import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import baseApi from "../../api/baseApi";

import { Slide, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const initialState = {
  agreement: {},
  agreementLoading: true,
  agreementRefresh: true,

  agreementDetails: {},
  agreementDetailsLoading: true,
  agreementDetailsRefresh: true,

  agreements: [],
  agreementsLoading: true,
  agreementsRefresh: true,

  agreementsAgency: [],
  agreementsAgencyLoading: true,
  agreementsAgencyRefresh: true,

  isFindPlate: {},
  isFindPlateLoading: false,
  isFindPlateRefresh: false,

  agreementPortal: {},
  agreementPortalCustomer: {},
  agreementPortalLoading: true,
  agreementPortalRefresh: true,

  agreementInvoice: null,
  agreementInvoiceLoading: true,
  agreementInvoiceRefresh: true,

  createAgreementLoading: false,
  updateAgreementLoading: false,
  deleteAgreementLoading: false,
  payAgreementLoading: false,
};

export const fetchAgreement = createAsyncThunk(
  "agreement/fetchAgreement",
  async (id) => {
    if (!id) throw new Error("Id bulunamadı!");

    const loadingToast = toast.loading("Yükleniyor...", {
      position: "top-center",
      transition: Slide,
    });

    try {
      const response = await baseApi.get(`/Aggreement/${id}`);

      toast.dismiss();

      return response.data.Value;
    } catch (error) {
      toast.update(loadingToast, {
        render: "Hata: " + error.response.data.Error.Description,
        type: "error",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const fetchAgreementDetails = createAsyncThunk(
  "agreement/fetchAgreementDetails",
  async (id) => {
    if (!id) throw new Error("Id bulunamadı!");

    const loadingToast = toast.loading("Yükleniyor...", {
      position: "top-center",
      transition: Slide,
    });

    try {
      const response = await baseApi.get(
        `/Aggreement/GetAggreementWithUserInfo?AggreementId=${id}`
      );

      toast.dismiss();

      return response.data.Value;
    } catch (error) {
      toast.update(loadingToast, {
        render: "Hata: " + error.response.data.Error.Description,
        type: "error",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const fetchAgreements = createAsyncThunk(
  "agreement/fetchAgreements",
  async () => {
    try {
      const response = await baseApi.get(`/Aggreement`);

      return response.data.Value;
    } catch (error) {
      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const createPayAgreement = createAsyncThunk(
  "agreement/createPayAgreement",
  async (values) => {
    if (!values) {
      throw new Error("Veri bulunamadı!");
    }

    const data = {
      cardHolderName: values.cardHolderName,
      cardNumber: values.cardNumber,
      expMonth: values.expMonth,
      expYear: values.expYear,
      cvc: values.cvc,
      installmentNumber: values.installmentNumber,
      posId: values.posId,
      plate: values.plate,
      modelYear: values.modelYear,
      usageType: values.usageType,
      brand: values.brand,
      model: values.model,
      customerName: values.customerName,
      phoneNumber: values.phoneNumber,
      email: values.email,
      taxNumber: values.taxNumber.trim(),
      taxOffice: values.taxOffice,
      city: values.city,
      district: values.district,
      address: values.address,
      agencyId: values.agencyId,
      packageId: values.packageId,
      description: values.description,
      customerId: values.customerId,
      appType: "portal",
      isSecure: values.isSecure,
      paymentType: parseInt(values.paymentType),
      bulkSaleId: null,
    };

    const loadingToast = toast.loading("Lütfen bekleyin!", {
      position: "top-center",
      transition: Slide,
    });

    try {
      const response = await baseApi.post(`/Aggreement/CreateAggreement`, data);

      if (parseInt(values.paymentType) == 0) {
        if (values.isSecure) {
          document.open();
          document.write(response.data.Value);
          document.close();
        } else {
          window.location.href = response.data.Value;
        }
      }

      toast.dismiss(loadingToast);

      return response.data.Value;
    } catch (error) {
      toast.update(loadingToast, {
        render: "Hata: " + error.response.data.Error.Description,
        type: "error",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      throw new Error(
        JSON.stringify(error.response?.data?.Error) || error.response?.status
      );
    }
  }
);

export const payAgreement = createAsyncThunk(
  "agreement/payAgreement",
  async (values) => {
    if (!values) {
      throw new Error("Veri bulunamadı!");
    }

    const data = {
      cardHolderName: values.cardHolderName,
      cardNumber: values.cardNumber,
      expMonth: values.expMonth,
      expYear: values.expYear,
      cvc: values.cvc,
      installmentNumber: values.installmentNumber,
      posId: values.posId,
      agreementId: values.agreementId,
      appType: "portal",
      isSecure: values.isSecure,
      paymentType: parseInt(values.paymentType),
    };

    const loadingToast = toast.loading("Lütfen bekleyin!", {
      position: "top-center",
      transition: Slide,
    });

    try {
      const response = await baseApi.post(`/Aggreement/PayAgreement`, data);

      if (parseInt(values.paymentType) == 0) {
        if (values.isSecure) {
          document.open();
          document.write(response.data.Value);
          document.close();
        } else {
          window.location.href = response.data.Value;
        }
      }

      toast.dismiss(loadingToast);

      return response.data.Value;
    } catch (error) {
      toast.update(loadingToast, {
        render: "Hata: " + error.response.data.Error.Description,
        type: "error",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const showAgreement = createAsyncThunk(
  "agreement/showAgreement",
  async (id) => {
    if (!id) throw new Error("Id bulunamadı!");

    try {
      const response = await baseApi.get(`/ShowAgreement/${id}`);

      return response.data.Value;
    } catch (error) {
      toast.error("Hata: " + error.response.data.Error.Description, {
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const fetchAgreementInvoice = createAsyncThunk(
  "agreement/fetchAgreementInvoice",
  async (values) => {
    if (!values) throw new Error("Veri bulunamadı!");

    const loadingToast = toast.loading("Yükleniyor...", {
      position: "top-center",
      transition: Slide,
    });

    try {
      const response = await baseApi.post(
        `/Aggreement/GetAgreementInvoice?AgreementId=${values.id}&ContentType=${values.type}`
      );

      toast.dismiss();

      const byteCharacters = atob(response.data.Value);
      const byteNumbers = new Array(byteCharacters.length)
        .fill()
        .map((_, i) => byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(blob);

      window.open(fileURL, "_blank");

      return response.data.Value;
    } catch (error) {
      toast.update(loadingToast, {
        render: "Hata: " + error.response.data.Error.Description,
        type: "error",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const agreementSlice = createSlice({
  name: "agreement",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAgreement.pending, (state, action) => {
        state.agreement = {};
        state.agreementLoading = true;
      })
      .addCase(fetchAgreement.fulfilled, (state, action) => {
        state.agreement = action.payload;
        state.agreementLoading = false;
      })
      .addCase(fetchAgreement.rejected, (state, action) => {
        state.agreement = {};
        state.agreementLoading = false;
      });

    builder
      .addCase(fetchAgreementDetails.pending, (state, action) => {
        state.agreementDetails = {};
        state.agreementDetailsLoading = true;
      })
      .addCase(fetchAgreementDetails.fulfilled, (state, action) => {
        state.agreementDetails = action.payload;
        state.agreementDetailsLoading = false;
      })
      .addCase(fetchAgreementDetails.rejected, (state, action) => {
        state.agreementDetails = {};
        state.agreementDetailsLoading = false;
      });

    builder
      .addCase(fetchAgreements.pending, (state, action) => {
        state.agreements = [];
        state.agreementsLoading = true;
      })
      .addCase(fetchAgreements.fulfilled, (state, action) => {
        state.agreements = action.payload;
        state.agreementsLoading = false;
      })
      .addCase(fetchAgreements.rejected, (state, action) => {
        state.agreements = [];
        state.agreementsLoading = false;
      });

    builder
      .addCase(payAgreement.pending, (state, action) => {
        state.payAgreementLoading = true;
      })
      .addCase(payAgreement.fulfilled, (state, action) => {
        state.payAgreementLoading = false;
        state.agreementsRefresh = !state.agreementsRefresh;
      })
      .addCase(payAgreement.rejected, (state, action) => {
        state.payAgreementLoading = false;
      });

    builder
      .addCase(showAgreement.pending, (state, action) => {
        state.agreementPortal = {};
        state.agreementPortalCustomer = {};
        state.agreementPortalLoading = true;
      })
      .addCase(showAgreement.fulfilled, (state, action) => {
        state.agreementPortal = action.payload.Aggreement;
        state.agreementPortalCustomer = action.payload.Customer;
        state.agreementPortalLoading = false;
      })
      .addCase(showAgreement.rejected, (state, action) => {
        state.agreementPortal = {};
        state.agreementPortalCustomer = {};
        state.agreementPortalLoading = false;
      });

    builder
      .addCase(fetchAgreementInvoice.pending, (state, action) => {
        state.agreementInvoice = null;
        state.agreementInvoiceLoading = true;
      })
      .addCase(fetchAgreementInvoice.fulfilled, (state, action) => {
        state.agreementInvoice = action.payload;
        state.agreementInvoiceLoading = false;
      })
      .addCase(fetchAgreementInvoice.rejected, (state, action) => {
        state.agreementInvoice = null;
        state.agreementInvoiceLoading = false;
      });
  },
});

export default agreementSlice.reducer;
